module.exports = __webpack_public_path__ + "static/media/panel-reward.fb0b6a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/schedule/panel-reward.png
// module id = 2112
// module chunks = 6